var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavesDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    viewBox: "0 0 1440 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,700 C 0,700 0,233 0,233 C 98.25,246.89285714285714 196.5,260.7857142857143 324,257 C 451.5,253.21428571428572 608.25,231.74999999999997 746,242 C 883.75,252.25000000000003 1002.5,294.2142857142857 1115,298 C 1227.5,301.7857142857143 1333.75,267.3928571428571 1440,233 C 1440,233 1440,700 1440,700 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "#65b3bf96",
    transform: "rotate(-180 720 350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,700 C 0,700 0,466 0,466 C 124.60714285714286,486.5 249.21428571428572,507 362,490 C 474.7857142857143,473 575.75,418.49999999999994 680,391 C 784.25,363.50000000000006 891.7857142857142,363.00000000000006 1019,380 C 1146.2142857142858,396.99999999999994 1293.107142857143,431.5 1440,466 C 1440,466 1440,700 1440,700 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "#5ea0aa",
    transform: "rotate(-180 720 350)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesDouble);
export default __webpack_public_path__ + "static/media/waves-double.a0e615da7647b866826838513059a664.svg";
export { ForwardRef as ReactComponent };